<template>
    <span>{{ views }} views</span>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import axios from 'axios'

export default {
  name: 'YoutubeView',
  mounted () {
    axios({
      method: 'POST',
      url: ajaxurl.url + '/video/youtube_view',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: $.param({
        youtube_id: this.youtube_id
      })
    }).then(resp => {
      this.views = resp.data.view
    })
  },
  data () {
    return {
      views: ''
    }
  },
  props: {
    youtube_id: String
  }
}
</script>
